import * as catalogos from './catalogos/tr';
export const locale = {
  lang: 'tr',
  data: {
    'CERTIFICARV3': {
      'GUAR_CAMB': 'Değişiklikler kaydediliyor ...',
      'CATALOGOS': {
        'SECCIONES': catalogos.secciones,
        'PREGUNTAS': catalogos.preguntas,
        'ABIERTAS': catalogos.abiertas,
        'PREG_ESPECI': catalogos.preguntasEspeciales,
      },
      'TITULO_TAB_PREG': 'Sorular',
      'TITULO_TAB_TRAD': 'Çeviri',
      'TITULO_TAB_PREV': 'Önizleme',
      'TAB_PREGUNTAS':{
        'CLA':'Anahtar:',
        'BTN_CONFIG_PLA': 'Şablon yapılandırması',
        'SLI_VER_US_EMPRE': 'İşletme kullanıcısı olarak görüntüle',
        'ETI_INSTNES': 'Aşağıdaki adımları izleyerek bir şablonda yer alan soruların bir listesini yükleyebilirsiniz:',
        'ETI_INST1': 'Şablonu indirin',
        'ETI_INST2': 'Formata göre soruları şablonu doldurun',
        'ETI_INST3': 'Soruları içeren şablonu yükleyin',
        'ETI_INST_NOT': 'Not: genel bir şekilde veya mevcut her bölüm içinde bir soru listesi yükleyebilirsiniz',
        'ETI_SECCI_NOT_GRU': 'Bu bölümde grup yok',
        'INST_AGRE_GRUP': 'Aşağıdaki düğmeyi kullanarak bir grup soru ekleyin',
        'BTN_AGRE_GRUP': 'Grup ekle',
        'INST2_AGRE_GRUP': 'Bu gruba daha sonra soru ekleyebilirsiniz',
        'ETI_DETEC_CAMB_PLAN': 'Orijinal şablonda değişiklikler tespit edildi',
        'BTN_GUAR_CAMB': 'Değişiklikleri kaydet',
        'BTN_GUAR_CAMB_NEW_PLAN': 'Yeni şablon olarak kaydet',
        'MAT_DESC_PLAN': 'Şablonu indir',
        'ETI_LIS_GRUP': 'Grup listesi',
        'MAT_CHIP_PRE_EXTR_SI': 'Ekstra sorular mevcut:',
        'MAT_CHIP_PRE_EXTR_NO': 'Artık ekstra soru ekleyemezsiniz',
        'MAT_CHIP_PRE_EXTR_ILIM': 'Sınırsız ekstra soru',
        'ETI_INST_COLO_CUR': 'Mevcut eylemleri görmek için imleci herhangi bir grubun üzerine getirin',
        'MAT_EDIT_NOMB_SECC': 'Grubun adını düzenleyin',
        'MAT_DELET_SECC': 'Bu grubu kaldır',
        'MAT_AGRE_SECC_ARRI': 'Yukarıya bir grup ekleyin',
        'ETI_SECC_SIN_PREG': 'Bu grupta soru yok',
        'ETI_SECC_INST_COLO_CUR': 'Mevcut eylemleri görmek için imleci bir sorunun üzerine getirin',
        'ETI_PREG_OPCIO_EDITA': 'İsteğe bağlı düzenlenebilir soru',
        'ETI_PREG_OPCIO_NO_EDITA': 'İsteğe bağlı düzenlenemez soru',
        'ETI_PREG_OPCIO_OBLI_EDITA': 'Zorunlu düzenlenebilir soru',
        'ETI_PREG_OPCIO_OBLI_NO_EDITA': 'Zorunlu düzenlenemez soru',
        'ETI_PREG_RESP_OBLI_NO_EDITA':'Gerekli soru cevabı',
        'MAT_FALT_OPC_RESP': 'Yanıt seçenekleri eksik',
        'ETI_FALT_OPC_RESP': 'Soru cevap seçenekleri eksik',
        'MAT_NO_GUAR_CATA': 'Henüz kataloğa kaydedilmedi',
        'ETI_PREG_NO_GUAR_CATA': 'Soru henüz kataloğa kaydedilmedi',
        'MAT_CHIP_TIP': 'tür',
        'MAT_TOOL_DETA_PREG': 'Soru ayrıntısı',
        'BTN_EDIT_PREG': 'Ayrıntılara bakınız',
        'MAT_TOOL_MOVE_PREG': 'Bu soruyu taşıyın',
        'BTN_EDIT_ES_PREG': 'Bu soruyu düzenleyin',
        'BTN_DELE_ES_PREG': 'Bu soruyu sil',
        'MAT_TOOL_AGRE_PREG_ARRI': 'Yukarı soru ekle',
        'MAT_TOOL_AGRE_PREG_ABAJ': 'Aşağıya soru ekleyin',
        'MAT_LABE_SELE_VERSI_PREG': 'Sorunun bir versiyonunu seçin',
        'MAT_LABE_TEX_PREG': 'Soru metni',
        'MAT_LABE_TEX_PREG_KEY':'Özel Soru Anahtarı',
        'ETI_CUE_SIG_ACC_PREG': 'Bu soru için aşağıdaki eylemlere güvenin',
        'MAT_CARD_MAES': 'Ana katalog',
        'ETI_DETEC_CAMB_TEX_PREG': 'Soru metninde değişiklikler tespit edildi',
        'MAT_TOOL_YET_NO_GUA_CAT': 'Henüz kataloğa kaydedilmedi',
        'ETI_ESTA_PREG_NO_GUAR_CATA': 'Bu soru kataloğa kaydedilmedi',
        'ETI_GUAR_PREG': 'Soruyu kaydet',
        'ETI_GUAR_CAMB': 'Değişiklikleri kaydet',
        'MAT_SLIDE_PREG_EDIT': 'Düzenlenebilir soru',
        'MAT_SLIDE_PREG_DELET': 'Çıkarılabilir soru',
        'MAT_SLIDE_PREG_REQUI': 'Zorunlu cevap',
        'ETI_AGRE_PREG': 'Soru ekle',
        'ETI_GRUP_PREG ':' Soru grubu',
        'ETI_SECC_ESP ':' Özel Bölüm ',
        'ETI_KEY_NO_EMPL':'Özel bölüm anahtarı kullanılmıyor',
        'ETI_FALT_KEY_SEC_ESP':'*Özel bölüm anahtarı eksik',
        'ETI_CLA_GRU_LIS':'anahtar kelime:',
        'DIALOG_MODAL':{
          'ETI_MOVE_PREG': 'Soruyu taşı',
          'ETI_INTS_SELEC_SECC_MOVE': 'Soruyu taşımak istediğiniz grubu seçin',
          'ETI_NOT_PREG_MOVE1': 'NOT:',
          'ETI_NOT_PREG_MOVE2': 'Soru, seçilen grubun sonuna taşınacak',
          'BTN_CANCELAR': 'İptal',
          'ETI_CONFI_PLAN': 'Şablon yapılandırması',
          'ETI_DATOS_PLAN': 'Şablon verileri:',
          'ETI_NOMB': 'Ad:',
          'ETI_SECC': 'Gruplar:',
          'ETI_PREG': 'Sorular:',
          'ETI_NOT_CONF_CONT_SECC': 'NOT: Bu kontrollerin yapılandırması, bir işletme türü kullanıcısı olarak görüntü modunda şablondaki tüm gruplar ve sorular için geçerlidir.',
          'ETI_PERMI_SECC ':' Grup izinleri ',
          'ETI_AGRE_SECC_NEW ':' Yeni grup ekle ',
          'ETI_MOVE_SECC ':' Grupları taşı ',
          'ETI_EDIT_TITU': 'Başlığı düzenle',
          'ETI_DELET_SECC': 'Grupları silin',
          'ETI_NOMB_OBL_GRUP_NEW':'Yeni gruplarda zorunlu isimler',
          'ETI_ENABLE_SEC_ESP': 'Özel soruları / bölümleri etkinleştir',
          'ETI_PERMIS_PREG': 'Her grup için soru izinleri:',
          'ETI_AGRE_PREG_NEW': 'Yeni sorular ekle',
          'ETI_AGRE_PREG_CATAL': 'Katalog soruları ekle',
          'ETI_MOVE_PREGS': 'Soruları taşıyın',
          'ETI_EDIT_PREG': 'Soruları düzenle',
          'ETI_DELET_PREG': 'Soruları sil',
          'ETI_PREG_NEW_MAX': 'Yeni maksimum sorular',
          'ETI_MAX_PREG_NEW': 'Maksimum yeni soru',
          'ETI_ENABLE_AUDIOS': 'Ses parçalarını etkinleştir',
          'ETI_DEMOGRAF': 'Demografi',
          'ETI_ABIER': 'Aç',
          'ETI_PRAC4ALL': '4All Uygulamaları',
          'ETI_ADICIO': 'Ek',
          'BTN_SAL': 'Çıkış',
          'ETI_INST_AGRE_PREG_CAT': 'Katalog sorusu ekle',
          'ETI_BUSC_SELECC_PREG_PLAN': 'Bu ekranda şablona eklenecek soruları arayabilir ve seçebilirsiniz',
          'ETI_VER_LIS_PREG_SELEC_3_PEST': 'Seçili soruların listesini bu pencerenin üçüncü sekmesinde görebilirsiniz',
          'TITULO_TAB_LIS_PREG':'Soru listesi',
          'TITULO_TAB_BUSC_PREG':'Soru ara',
          'TITULO_TAB_PREG_SELEC':'Seçili sorular',
          'PASO_1':'Aşama 1',
          'PASO_2':'Adım 2',
          'ETI_SELEC_PREG_LIS_CAT': 'Katalogdaki listeden soruyu seçin',
          'ETI_SELEC_PREG': 'Bir soru seçin',
          'ETI_YA_SELEC_NUM_MAX_PREG': 'Şablonda izin verilen maksimum ekstra soru sayısını zaten seçtiniz',
          'ETI_PREG_MS_UNA_VERS': 'Bu sorunun birden fazla sürümü var, görüntülemek istediğinizi seçin',
          'ETI_SELEC_VERS': 'Bir sürüm seçin',
          'ETI_PREG_SELECCIONDA': 'Seçili soru:',
          'ETI_AGRE_PREG': 'Soru ekle',
          'ETI_OK_AGRE_PREG_LIST': '<b> Soru, soru listesine eklendi </b>, şablona eklemek için daha fazla soru seçebilir ve ekleyebilirsiniz',
          'ETI_OK_AGRE_PREG_LIST2': 'Seçili soruların listesini bu pencerenin üçüncü sekmesinde de görebilirsiniz',
          'ETI_ESCR_TEXT_BUSC': 'Aramak istediğiniz sorunun metnini girin',
          'ETI_BUSC_PREG_COINC': 'Eşleşen sorular aranıyor',
          'ETI_NO_ENCO_PREG': 'Girilen metinle hiçbir soru bulunamadı, farklı bir metin deneyin',
          'ETI_RESUL_BUSC': 'Arama sonuçları',
          'BTN_ELEG': 'Seç',
          'ETI_REGRE_RESUL': 'Sonuçlara dön',
          'ETI_PREG_SELECC_MOMEN': 'Şimdiye kadar seçilen soruların listesi',
          'MAT_TOOL_ELEG_VERSI': 'Başka bir sürüm seçin',
          'MAT_TOOL_ELI_VERSI':'Sürümü kaldır',
          'BTN_REGRES': 'Geri Dön',
          'BTN_ELIG_VERSI': 'Sürüm seçin',
          'MAT_TOOL_QUITA_LIS': 'Listeden kaldır',

          'BY_TEXT': 'Soru metnine göre',
          'BY_KEYWORDS': 'Anahtar kelimelere göre',
          'QUESTION_TEXT': 'Soru metni',
          'QUESTION_KEYWORDS': 'anahtar kelimeler',
          'QUESTION_HINT': 'Anahtar kelimeler <b> # </b> karakteriyle başlamalı ve virgülle ayrılmalıdır'
        },
        'DETALLE':{
          'ETI_DETALL_PREG': 'Soru ayrıntısı',
          'ETI_LAB_TEX_PREG': 'Soru metni',
          'PLACE_HOL_TEX_PREG': 'Soru metni',
          'MAT_TOOL_EDIT_PREG': 'Bu soruyu düzenleyin',
          'MAT_CARD_OPC_RESP': 'Yanıt seçenekleri',
          'MAT_TOOL_EDIT_RESP': 'Bu yanıtı düzenle',
          'MAT_TOOL_DELET_RESP': 'Bu yanıtı sil',
          'ETI_AGRE_OPCI_RESP': 'Bir cevap seçeneği ekle',
          'ETI_SELEC_VERSI_PREG': 'Sorunun bir versiyonunu seçin',
          'ETI_CUENT_SIG_ACC_PREG': 'Bu soru için aşağıdaki eylemlere güvenin',
          'ETI_DETEC_CAMB_TEXMAES': 'Ana katalog',
          'ETI_CATA_MAES': 'Ana katalog',
          'ETI_DETEC_CAMB_TEX_PREG': 'Soru metninde değişiklikler tespit edildi',
          'ETI_DETEC_CAMB_TEX_RESP': 'Yanıt seçeneklerinde değişiklik algılandı',
          'ETI_PREG_NO_GUAR_CATA': 'Bu soru kataloğa kaydedilmedi',
          'ETI_GUAR_PREG': 'Soruyu kaydet',
          'ETI_GUAR_CAMB': 'Değişiklikleri kaydet',
          'ETI_BORR_PREGUN':'Soruyu sil',
          'ETI_DELET_PREG': 'Soruyu sil',
          'MAT_CARD_PLAN': 'Şablon',
          'MAT_SLIDE_PREG_EDIT': 'Düzenlenebilir soru',
          'MAT_SLIDE_PREG_DELET': 'Çıkarılabilir soru',
          'MAT_SLIDE_PREG_REQUI': 'Zorunlu cevap',
          'BTN_REGRES': 'Geri Dön',
          'ETI_NEW_PREG': 'Yeni soru',
          'ETI_ESCR_TEXT_SELEC_TIP_PRE': 'Metni yazın ve yeni soru için cevap türünü seçin',
          'ETI_ESCR_TEXT_AGRE_OPCI_RESP': 'Metni yazın ve yeni soru için cevap seçenekleri ekleyin',
          'ETI_TIP_PREG': 'Soru türü',
          'ETI_TIP_RESP': 'Yanıt türü',
          'ETI_TIP_FORM':'soru formatı',
          'ETI_PREG_ESP_FLD': 'Özel soru anahtarı',
          'ETI_PREG_ESP_HNT': 'Özel soru için anahtarı girin',
          'BTN_CANCELAR': 'İptal',
          'BTN_CONTINU': 'Devam Et',
          'ETI_NEW_PRAC_4ALL': 'Yeni 4All uygulama',
          'ETI_INST_NAME_DESC_4ALL': 'Yeni 4All uygulaması için isim ve açıklama girin',
          'ETI_LABE_NAME': 'Uygulama adı',
          'ETI_LABE_DESC': 'Uygulamanın açıklaması',
          'ETI_CLAVE_DEMOGR': 'Karakterden başlayarak soruyu tanımlayan bir veya daha fazla anahtar kelime yazın',
          'ETI_CLAVE_DEMOGR1': 've virgülle ayrılmış',
          'ETI_CLAVE_DEMOGR2': 'NOT: Anahtar sözcükler yalnızca bu pencereyi kapatırken bu soruyu kataloğa kaydederseniz kaydedilecektir.',
          'ETI_PALA_CLAVE_DEMOGR': 'Anahtar Kelimeler',
          'ETI_SELE_TIPO_DEMOGR': 'Yeni soruya karşılık gelen demografi türünü seçin',

          'MAT_TOOL_CONFIG_RESP':'Bu yanıtı yapılandır',
          'MAT_SLIDE_RESP_EDIT':'Düzenlenebilir cevap',
          'MAT_SLIDE_RESP_DELET':'Çıkarılabilir cevap',
          'MAT_SLIDE_RESP_TIPO_OTRO':'"Diğer" yazın',
          'MAT_TOOL_NEWVERS_PREG':'Yeni versiyon olarak kaydet',
          'NOTA_PREG_MOD': 'NOT: Bu sorunun metni değiştirildi, isterseniz yeni bir versiyon olarak kaydedebilirsiniz.',
          'RESPUESTA_TIPO_OTRO':' - cevap türü "Diğer"',

          'TIPO_DEMOGRAFICO':'demografik tür',
          'SIN_TIPO_DEMOGRAFICO':'Bu soru için demografik tür seçilmedi'

          //     {{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_LABE_DESC'|translate}}
        },
        'MSJ_MODALES':{
          'TITU_MOD_GUA_CAM_TEMP': 'Yeni şablon',
          'TEXT_MOD_GUA_CAM_TEMP': 'Yeni şablonun adını yazın',
          'BTN_CAN_MOD_GUA_CAM_TEMP': 'İptal',
          'BTN_AGRE_MOD_GUA_CAM_TEMP': 'Ekle',
          'RETUR_MOD_GUA_CAM_TEMP': 'İsim için bir metin girmediniz',
          'SUCC_TEXT_MOD_GUA_PLAN': 'Yeni şablon doğru şekilde kaydedildi',
          'TITU_MOD_GUA_CAM_TEMP2': 'Orijinal şablonda yapılan değişiklikleri kaydetmek istiyor musunuz? UYARI: Bu şablonla bir ürün atandığında, şimdiye kadar yapılan tüm değişiklikler dahil edilecektir ',
          'BTN_CONTI_MOD_GUA_CAM_TEMP': 'Devam Et',
          'SUCC_TEXT_MOD_GUA_PLAN_ORG': 'Orijinal şablonda yapılan değişiklikler doğru şekilde kaydedildi',
          'MENS_1': 'Bölüme ne tür bir soru eklemek istiyorsunuz?',
          'MENS_2': 'İki seçeneğiniz var',
          'BTN_NEW': 'Yeni',
          'BTN_D_CATA': 'Katalogdan',
          'TITU_MOD_CARG_LIS_COLAB_P1': 'Bu dosya şunları içerir',
          'TITU_MOD_CARG_LIS_COLAB_P2': 'bölümler ve toplam',
          'TITU_MOD_CARG_LIS_COLAB_P3': 'Questions.WARNING: Bu dosyayı yüklemeye devam ederseniz, şu anda sahip olduğunuz sorular ve gruplar değiştirilecektir',
          'TITU_TEX_MOD_CARG_LIS_COLAB': 'İki seçeneğiniz var',
          'BTN_AGRE_PREGU': 'Soruları ekleyin',
          'BTN_CANC_PREGU': 'Soruları sil',
          'TEXT_MOD_SUCCE_CARG_LIS_COLAB': 'Sorular doğru şekilde eklendi',
          'TEXT_MOD_NOT_CARG_LIS_COLAB': 'Sorular silindi',
          'TEXT_MOD_ERRO_CARG_LIS_COLAB': 'Seçili dosyada hatalar var ve yüklenemiyor. Tüm satırların doğru sırayla yerleştirildiğini tekrar kontrol edin ve tekrar deneyin ',
          'BTN_OK': 'Tamam',
          'TITU_MOD_NEW_SECC': 'Yeni bölüm',
          'TEXT_MOD_NEW_SECC': 'Yeni bölümün adını girin',
          'TEXT_SUCC_PREG_AGRE': 'Soru doğru şekilde eklendi',
          'TITU_MOD_EDI_SECC': 'Bölüm adını değiştir',
          'TEXT_SUCC_MODIF_SECC': 'Bölüm adı doğru şekilde değiştirildi',
          'TEXT_SUCC_MODIF_GRU':'Grup adı değiştirildi',
          'TITU_MOD_DELE_SECC1': 'Bu bölümü silmek istediğinizden emin misiniz?',
          'BTN_SI': 'Evet',
          'BTN_NO': 'Hayır',
          'TITU_MOD_DELE_SECC2': 'Bu bölüm bir veya daha fazla soru içeriyor, bu sorularla ne yapmak istiyorsunuz',
          'BTN_DELE_PRE': 'Soruları sil',
          'BTN_CAN_TRAN': 'Önceki bölüme aktarın',
          'TEX_SUCC_DELE_PREG': 'Bölüm doğru şekilde silindi',
          'TITU_AGRE_NEW_PREG': 'Yeni soru',
          'TEXT_AGRE_NEW_PREG': 'Yeni soru metnini girin',
          'TITU_EDIT_PREG_MOD_PREG': 'Soruyu değiştir',
          'TITU_EDIT_PREG_MOD_PRACT': 'Uygulamayı değiştir',
          'TITU_EDIT_PREG_MOD_DESCRI': 'Açıklamayı değiştir',
          'TEXT_MOD_PREG_SUCC': 'Soru doğru şekilde değiştirildi',
          'TITU_2_OPCIO': 'Bu değişikliği kaydetmek için iki seçeneğiniz var',
          'BTN_CONF_ACT': 'Soruyu güncelle',
          'BTN_CANC_NEW': 'Yeni soru olarak',
          'BTN_CONF_ACT_VERSION':'Bu sürümü güncelle',
          'BTN_CANC_NEW_VERSION':'Yeni sürüm olarak',
          'TEX_CONFIR_MSG1': 'Soru doğru şekilde değiştirildi',
          'TEX_CONFIR_MSG2': 'Uygulama doğru şekilde değiştirildi',
          'TEX_CONFIR_MSG3': 'Açıklama doğru şekilde değiştirildi',
          'TITU_DELE_PREG': 'Bu soruyu silmek istediğinizden emin misiniz?',
          'TEXT_SUCC_PREG': 'Soru doğru şekilde silindi',
          'TITU_MOD_DELE_SECC_TEMPLA': 'Bu bölümü silmek istediğinizden emin misiniz?',
          'TITU_MOD_DELE_SECC_TEMPLA2': 'Bu bölüm bir veya daha fazla soru içeriyor, bu sorularla ne yapmak istiyorsunuz',
          'TEX_SUCC_GUAR_PREG_': 'Soru doğru kaydedildi',
          'TITU_MOD_DELE_PREG_MG': 'Soruyu katalogdan silmek istediğinizden emin misiniz? UYARI: Bu eylem tersine çevrilemez ve soru, şu anda onu içeren şablonlarda artık kullanılamayacak ',
          'TEX_CONFIR_MSG4_DELE': 'Soru, katalogdan doğru bir şekilde kaldırıldı',
          'TEX_GUAR_TRADU_SUCC': 'Çeviri doğru şekilde kaydedildi',
          'TEX_MOVE_PREG_SECC': 'Soru başka bir bölüme taşındı',
          'TEX_SUCC__PRAC_4ALL': 'Uygulama doğru şekilde eklendi',
          'MOD_MOD_AGRE_PREG': 'Soru listeye doğru bir şekilde eklendi',
          'MOD_MOD__MODIF_VERSI_PREG': 'Sorunun sürümü doğru bir şekilde değiştirildi',
          'MOD_MOD__QUIT_PREG_LIST': 'Sorunun sürümü doğru bir şekilde değiştirildi',
          'TITU_NUE_OPC_RESP': 'Yeni cevap seçeneği',
          'TEXT_NUE_OPC_RESP': 'Yeni seçenek için metin girin',
          'TEXT_NO_TEXT_PREG': 'Soru için bir metin girmediniz',
          'TEXT_AGRE_OPC_RESP': 'Yanıt seçeneği doğru şekilde eklendi',
          'MOD_EDIT_RESP': 'Cevap seçeneğini değiştir',
          'MOD_EDIT_MODIF_OPC_RESP': 'Cevap seçeneği doğru şekilde değiştirildi',
          'MOD_COMFIR_DELE_OPC_RESP': 'Bu cevap seçeneğini silmek istediğinizden emin misiniz?',
          'MOD_SUCC_DELE_OPC_RESP': 'Cevap seçeneği doğru bir şekilde silindi',
          'MOD_NO_CONT_SIN_HAB_AGRE_OPC_RESP': 'Soruya cevap seçenekleri eklemeden devam edilemez',
          'MOD_NO_CONT_SIN_HAB_ESCR_OPC_RESP': 'Önce soru metnini yazmadan devam edemezsiniz',
          'MOD_NO_CONT_SIN_HAB_ELE_TIP_RESP': 'Soru türünü seçmeden devam edemezsiniz',
          'MOD_AGRE_PREG_DONDE_GUARDAR': 'Yeni soruyu eklemeden önce kataloğa kaydedilmesini istiyor musunuz? Yoksa sadece bu ankette olmasını mı istiyorsunuz?',
          'MOD_AGRE_PREG_DONDE_GUARDAR_INFO': 'Kataloğa kaydederek dilerseniz diğer anketlere de açabilirsiniz.',
          'BOT_DONDE_GUARDAR_1': 'Kataloğa kaydedin',
          'BOT_DONDE_GUARDAR_2': 'Sadece bu ankete kaydedin',
          'MOD_SIN_TAGS': 'Soru için henüz en az bir anahtar kelime girmediniz',
          'MOD_SIN_OPC_RESP': 'Soru için henüz en az iki cevap seçeneği girmediniz',
          'MOD_SIN_TIPO_DEMO': 'Bu soru için henüz demografik türü seçmediniz',
          'MOD_SIN_CLA_ESPE': 'Özel soruya anahtarı henüz eklemediniz',
          'MOD_SIN_TIPO_RESP': 'Sorunun yanıt türünü seçmeden devam edemezsiniz',
          'MOD_RESP_DELOK': 'Cevap seçeneği başarıyla silindi',
          'MOD_RESP_DELCATOK': 'Soru, katalogdan başarıyla kaldırıldı',
          'MOD_RESP_ADDTAGOK': 'Anahtar kelime soruya doğru şekilde eklendi',
          'MOD_RESP_ADDTAGERR': 'Anahtar kelime # karakteriyle başlamadı',
          'MOD_RESP_DELTAGOK': 'Anahtar kelime, sorudan doğru bir şekilde kaldırıldı',
          'MOD_SAVE_CAMBIOS_PREGCAT': 'Bu katalog sorusuna yapılan değişiklikleri kaydederken, yapılan değişiklikler, varsa soru metinlerinin ve cevap seçeneklerinin yeni sürümleri olarak kaydedilecektir.n\n\ndevam etmek istiyor musun',
          'MOD_SAVE_CAMB_PREGCAT': 'Bu değişikliği soru metninde nerede saklamak istiyorsunuz?',
           'BTN_MOD_SAVE_CAMB_PREGCAT': 'Yalnızca bu ankette',
           'BTN_MOD_ACTUA_PREGCAT': 'Katalogdaki soruyu güncelleyin',
        }
      },
      'TAB_TRADUCCION':{
        'TEX_MOD_CARG': 'Yükleniyor',
        'TEXT_NO_ELEG_ADIC': 'Başka dil seçilmedi',
        'ERR_MSG_TRADU': 'Çeviri henüz tamamlanmadı',
        'TEX_IDIO_PRIN': 'Ana dil',
        'TEX_NAM_GRUP': 'Grup adı',
        'TEX_TRAD_NAM': 'Adın çevirisini girin',
        'TEX_NO_TRAD_TEXT': 'Çeviri metnini girmediniz',
        'TEX_TEX_PREG': 'Soru metni',
        'TEX_TEX_RESP ':' Yanıt metni ',
        'TEX__TRA_PREG': 'Sorunun çevirisini girin',
        'TEX__TRA_RESP': 'Cevabın çevirisini girin',
        'GUAR_TRA_NAM': 'Ad çevirisi kaydediliyor, lütfen bekleyin',
        'GUAR_TRA_PRE': 'Soru çevirisi kaydediliyor, lütfen bekleyin',
        'GUAR_TRA_RES': 'Cevap seçeneğinin çevirisi kaydediliyor, lütfen bekleyin',
        'INGR_TEX_PRAC_4ALL': 'Alıştırma',
        'INGR_TEX_TRADU_PRAC_4ALL': 'Alıştırma çevirisini girin',
        'INGR_TEX_DESCR_4ALL': 'Açıklama',
        'INGR_TEX_TRADU_DESCR_4ALL': 'Açıklamanın çevirisini girin',
        'GUAR_TRADU_PRAC ':' Pratik çevirisi kaydediliyor, lütfen bekleyin ... ',
        'GUAR_TRADU_DESCR ':' Açıklama çevirisi kaydediliyor, lütfen bekleyin ... ',
      },
      'TAB_PREVIEW':{
        'INST_SELECC_IDI ':' Soruların çevirilerini görüntülemek için bir dil seçin',
        'ETI_SIN_TRAD_PRE': '¡Çeviri metni eksik!',
      },
      'MODAL_AUDIO': {
        'TITULO': {
          'ADD': 'Ses parçası ekle',
          'CHANGE': 'Ses parçasını değiştir'
        },
        'SUBTITULO': 'Aşağıdaki seçeneklerden birini kullanarak bir ses parçasını bu soruyla ilişkilendirebilirsiniz.',
        'BOTONES': {
          'RESTART': 'Başlamak için geri dön',
          'NEXT': 'Sonraki',
          'BACK': 'Geri gitmek',
          'ACEPTAR': 'Kabul etmek',
          'CANCELAR': 'İptal'
        },
        'OPCIONES': {
          'GOOGLE': 'Otomatik anlatım oluştur',
          'RECORD': 'Bir anlatım kaydedin',
          'ARCHIVO': 'Bir mp3 dosyası yükleyin',
        },
        'PASOS': {
          'GOOGLE': {
            'TITULO': 'Otomatik anlatım oluşturmak için metni düzenleyebilirsiniz',
            'INPUT': 'Soru metni',
            'INPUT_TT': 'Soru metnini yazın',
            'NOTA': 'NOT: Bu metni değiştirmek, anketteki soru metnini değiştirmeyecektir.'
          },
          'RECORD': {
            'TITULO': 'Mikrofondan ses kaydetmeye başlamak için Kaydet düğmesine tıklayın',
            'NOTA': 'NOT: Mikrofonu tarayıcıya kullanmak için izin vermeniz gerekebilir.',
            'START': 'Kayda başla',
            'STOP': 'Ses kaydı, kaydı durdurmak için düğmeye tıklayın'
          },
          'ARCHIVO': {
            'INPUT': 'Yüklemek için buraya tıklayın veya ses dosyasını bu alana sürükleyin',
            'NOTA': 'NOT: Yalnızca MP3 formatı desteklenir'
          },
          'PREVIEW': {
            'GENERANDO': 'Ses üretiliyor, lütfen biraz bekleyin',
            'TITULO': 'Aşağıda yüklenen sesi dinleyebilirsiniz',
            'NOTA_1': 'Bu ses parçasını soruya kaydetmek istiyorsanız, Tamam düğmesini tıklayın.',
            'NOTA_2': 'Sesi değiştirmek istiyorsanız, Geri düğmesini tıklayın.',
            'NOTA_3': 'Yüklenen sesin türünü değiştirmek istiyorsanız, Başa Dön düğmesini tıklayın.'
          }
        },
        'MODALES': {
          'DESCARTAR': 'Önceki adıma geri döneceğinizden emin misiniz? \n\n Geçerli parça silinecek',
          'ARCHIVO_MAL': 'Yüklenen dosya bir ses parçası değil',
          'GUARDANDO': 'Ses parçası sorulacak şekilde kaydediliyor, bir dakika bekleyin',
          'BORRAR': 'Bu soruyla ilişkili ses parçasını silmek istediğinizden emin misiniz?',
          'CONFIRMAR_BORRAR': 'Onaylamak için, metin kutusuna kırmızı renkli kodu girin: \n\n',
          'BORRADO_OK': 'Sorunun ses parçası doğru şekilde silindi',
          'CODIGO_MAL': 'Girilen kod kırmızı ile gösterilen kodla eşleşmiyor',
          'AGREGANDO_PREGUNTAS': 'Seçilen sorular bölüme ekleniyor, lütfen biraz bekleyin'
        },
        'PREVIOS': {
          'TITULO': 'İlişkili ses parçası',
          'SIN_AUDIO': 'İlişkili bir ses parçası yok',
          'SIN_AUDIO_FORALL': 'Ses parçası yok',
          'ADD_AUDIO': 'Ses parçası ekle',
          'CON_AUDIO': 'Bu sorunun ses kaydı var',
          'PLAY': 'ses çal',
          'CHANGE': 'Sesi değiştir',
          'DELETE': 'Sesi sil',
          'AUDIO_STATEMENT_1': 'Açıklama 1\'in ses kaydı',
          'AUDIO_STATEMENT_2': 'İfade 2\'nin ses parçası',
        }
      },
      'MODAL_SEC_ESP': {
        'TITULO': 'Özel bölüm',
        'SUBTITULO_1': 'Bu soru grubu özel bölüm olarak oluşturulabilir, bu grubun soruları sadece aynı şifreye sahip ortak çalışanlara gösterilecektir.',
        'SUBTITULO_2': 'NOT: Ortak çalışan yükleme adımında en az bir ortak çalışanın bu özel bölümle ilişkilendirilmesi gerekir.',
        'TIPOS': {
          'NORMAL': 'Normal bölüm',
          'ESPECIAL': 'Özel bölüm'
        },
        'CAMPO': {
          'TITULO': 'Bölüm anahtarı',
          'TOOLTIP': 'Bu bölümün anahtarını yazın',
          'HINT': 'Boşluksuz',
          'ACEPTAR': 'Kabul etmek'
        },
        'MODALES': {
          'CONFIRM_DISABLE': 'Özel bölümleri devre dışı bırakırsanız, şu anda Özel bölüm olarak işaretlenen soru grupları normal soru gruplarına dönüştürülecek, bu değişiklik tüm soru bölümleri için geçerli olacaktır. \n\n Devam etmek istediğinizden emin misiniz?',
          'DISABLE_OK': 'Bulunan tüm özel bölümler normal soru gruplarına dönüştürüldü',
          'SIN_CLAVE': 'Özel bölümü kaydetmek için bölüm için bir anahtar girmeniz gerekir.'
        }
      }
    },
  }
};
